import React, { useState } from 'react';
import friendData from '../../friendData';
import FriendProfile from '../FriendProfile/FriendProfile';
import FriendCount from '../FriendCount/FriendCount';
import './Friend.css';

const Friend = () => {

    
    const userInfo = friendData.slice(0,15);
    const [users, setUsers] = useState(userInfo)
    const[userCount, setUserCount] = useState([]);

    const handleAddUser = (addUsers) =>{
        const newUser = [...userCount, addUsers];
        setUserCount(newUser)
    }

    return (
        <div className="user-container">
            <div className="UserCount">
                <FriendCount allUser = {userCount}></FriendCount>
            </div>

            <div className="users">
                {
                    users.map(user => <FriendProfile handleAddUser = {handleAddUser} user={user}></FriendProfile>)
                }
            </div>
            
        </div>
    );
};

export default Friend;